var borders_default = {
  "borderT": "SoOTb",
  "borderB": "hv4jj",
  "borderL": "g9QQ3",
  "borderR": "vrjvT",
  "borderColorOverride": "FWdBE"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
